var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1791_30013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9857 33.9715C26.3667 33.9715 33.9715 26.3667 33.9715 16.9857C33.9715 7.60477 26.3667 0 16.9857 0C7.60477 0 0 7.60477 0 16.9857C0 26.3667 7.60477 33.9715 16.9857 33.9715Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5146 4.24609V13.6626L25.4735 17.2189L17.5146 4.24609Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5146 4.24609L9.55469 17.2189L17.5146 13.6626V4.24609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5146 23.3213V29.7196L25.4788 18.7012L17.5146 23.3213Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5146 29.7196V23.3202L9.55469 18.7012L17.5146 29.7196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5146 21.8405L25.4735 17.2193L17.5146 13.665V21.8405Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55469 17.2193L17.5146 21.8405V13.665L9.55469 17.2193Z",
    fill: "white",
    fillOpacity: 0.602
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1791_30013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.9715,
    height: 33.9715,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.fba3dec5453eab7a93911e4059109dcd.svg";
export { ForwardRef as ReactComponent };